import type React from "react";
import {Panel, useStore} from "@xyflow/react";
import {Paper, Typography} from "@mui/material";
import {
    type CounterpartyNode,
    counterpartyName,
    tierLabel,
} from "~/pages/supplier-360/tabs/SupplierValueChain/components/chain/valueChainLayout";

/** Below this zoom level the card text is too small to read. */
const SHOW_BELOW_ZOOM = 0.8;

/**
 * The hovered counterparty at a readable size while the canvas is zoomed out, with the chain that
 * leads to it (focus › tier 1 › …) — the taxonomy builder's hovered-node panel. Render inside `<ReactFlow>`.
 */
export const ChainHoveredNodePanel: React.FC<{node: CounterpartyNode | undefined}> = ({node}) => {
    const zoomedOut = useStore(s => s.transform[2] < SHOW_BELOW_ZOOM);
    if (!node || !zoomedOut) return null;
    const {link, path, childCount} = node.data;

    return (
        <Panel position="top-left">
            <Paper variant="outlined" sx={{px: 1.5, py: 1, maxWidth: 360, boxShadow: 2}}>
                <Typography variant="caption" color="text.secondary" noWrap component="div">
                    {path.join(' › ')}
                </Typography>
                <Typography variant="subtitle2" fontWeight={700}>
                    {counterpartyName(link)}
                </Typography>
                <Typography variant="caption" color="text.secondary" component="div">
                    {tierLabel(link.tier)}
                    {childCount > 0 && ` · ${childCount} sub`}
                </Typography>
            </Paper>
        </Panel>
    );
};
